import React from 'react';
import cn from '@utils/cn';

type ChevronProps = {
  Icon: React.ElementType;
  className: string;
  onClick: () => void;
  isVisible: boolean;
};

export default function Chevron({ Icon, className, onClick, isVisible }: ChevronProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'absolute hidden items-center justify-center lg:flex',
        'h-8 w-8 rounded',
        'hover:bg-secondary cursor-pointer transition-colors',
        'fill-body-foreground hover:bg-input',
        className,
        { 'lg:hidden': !isVisible },
      )}
    >
      <Icon className="h-5 w-5" />
    </div>
  );
}
